const { v4: uuidv4 } = require('uuid');
import moment from 'moment';


window.addEventListener('load', function(){
  var elem = document.querySelector(`script[src="${process.env.MIX_PUSHER_HOST}/dist/js/sigma-chat-v2-sdk.js"]`);
  if(!elem){
    elem = document.querySelector(`script[src="/dist/js/sigma-chat-v2-sdk.js"]`);
  }
  var user = null;
  if(elem.getAttribute('data-user')) {
    try{
      user = JSON.parse(elem.getAttribute('data-user'));
    } catch(e){
      console.log('Sigma Chat: Invalid user data');
      user = null;
    }
  }


  new SigmaChat({
    id: elem.getAttribute('data-id') ?? 'sigmachatid',
    channel: elem.getAttribute('data-channel') ?? 'chat',
    keepHistory: elem.getAttribute('data-history'),
    hasSurvey: elem.getAttribute('data-survey') != null,
    noConfirmTerminate: elem.getAttribute('data-no-confirm-terminate') != null,
    user
  });
});

export class SigmaChat {
  static #user = null;
  static #clientId = null;
  static #state = 'disconnected';
  static #healthCheck = null;
  static #options = {
    id: 'sigmachatid',
    channel: 'chat',
    keepHistory: null,
    user: null
  }
  constructor(options) {
    SigmaChat.#options = { ...SigmaChat.#options, ...options };

    if (options?.user) {
      SigmaChat.#user = options.user;
    }

    if(options.keepHistory === ''){
      options.keepHistory = 30;
      SigmaChat.#options.keepHistory = 30;
    }
    if(sessionStorage && options.keepHistory){
      const history = JSON.parse(sessionStorage.getItem('sigma-chat-history'));

      if(history && moment().subtract(options.keepHistory, 'minutes').isBefore(moment(history.lastModified))){
        SigmaChat.#user = history.user;
        SigmaChat.#clientId = history.clientId;
        SigmaChat.#startChat(true, history.minimized);
        history.messages.forEach(message => {
          SigmaChat.#renderMessage(message, true);
        });
      } else {
        sessionStorage.removeItem('sigma-chat-history');
      }
    }
  }

  static #connectSocket() {
    window.Echo.connector.pusher.connection.strategy.transports.wss.transport.manager.livesLeft = Infinity;
    Echo.connect();
    Echo.channel(`chat.${this.#clientId}`)
      .listen('NewMessage', (e) => {
        this.#renderMessage({ system: true, ...e.message });
        var now = moment().toISOString();
        const formData = new FormData();
        formData.append('event', 'acknowledge');
        formData.append('datetime', now > (e.message.datetime ?? '') ? now : e.message.datetime);
        formData.append('clientId', this.#clientId);
        const options = {
          method: 'POST',
          body: formData
        }
        fetch(process.env.MIX_PUSHER_HOST + '/' + SigmaChat.#options.channel + '/sigmaV2/callback/' + SigmaChat.#options.id, options);
      })
      .listen('StatusEvent', (e) => {
        this.#setStatus(e.event.id, e.event.status);
      })
      .listen('NewVideo', (e) => {
        window.dispatchEvent(new CustomEvent('SigmaChat-Video', { detail: {tokenwebcam: e.message.tokenwebcam, tokenscreen: e.message.tokenscreen} }));
      })
      .listen('ConversationFile', (e) => {
        window.dispatchEvent(new CustomEvent('SigmaChat-File', { detail: {id: e.message.id, attachment: e.message.filename} }));
      })
      .listen('ChatEscalated', (e) => {
        window.dispatchEvent(new CustomEvent('SigmaChat-Escalated'));
      })
      .listen('ChatTerminated', (e) => {
        window.dispatchEvent(new CustomEvent('SigmaChat-Terminated'));
      })
      .listen('ChatTerminatedWithSurvey', (e) => {
        window.dispatchEvent(new CustomEvent('SigmaChat-TerminatedWithSurvey'));
      })
      .listen('ChatHistory', (e) => {
        e.history.events.forEach(message => {
          switch (message.type) {
            case 'message':
              this.#renderMessage({ system: true, ...message.data }, true);
              break;
            case 'escalated':
              window.dispatchEvent(new CustomEvent('SigmaChat-Escalated'));
              break;
            case 'terminated':
              window.dispatchEvent(new CustomEvent('SigmaChat-Terminated'));
              break;
            case 'terminatedWithSurvey':
              window.dispatchEvent(new CustomEvent('SigmaChat-TerminatedWithSurvey'));
              break;
            case 'video':
              window.dispatchEvent(new CustomEvent('SigmaChat-Video', {detail: {tokenwebcam: message.data.tokenwebcam, tokenscreen: message.data.tokenscreen}}));
              break;
          }
        });
        const formData = new FormData();
        formData.append('event', 'acknowledge');
        formData.append('datetime', moment().toISOString());
        formData.append('clientId', this.#clientId);
        const options = {
          method: 'POST',
          body: formData
        }
        fetch(process.env.MIX_PUSHER_HOST + '/' + SigmaChat.#options.channel + '/sigmaV2/callback/' + SigmaChat.#options.id, options);
      });
  }

  static #startChat(history = false) {

    if(!history && !this.#clientId){
      this.#clientId = uuidv4()
    }

    SigmaChat.#connectSocket();
    SigmaChat.#checkStatus();

    if(sessionStorage && SigmaChat.#options.keepHistory && !history){
      sessionStorage.setItem('sigma-chat-history', JSON.stringify({
        user: SigmaChat.#user,
        clientId: SigmaChat.#clientId,
        lastModified: moment().toISOString(),
        messages: []
      }));
    }
  }

  static #renderMessage(message, history = false) {
    if(!message.datetime){
      message.datetime = moment().toISOString();
    }
    if(sessionStorage && SigmaChat.#options.keepHistory && !history){
      const hist = JSON.parse(sessionStorage.getItem('sigma-chat-history'));
      if(hist){
        hist.messages.push(message);
        hist.lastModified = moment().toISOString();
        sessionStorage.setItem('sigma-chat-history', JSON.stringify(hist));
      }
    }
    window.dispatchEvent(new CustomEvent('SigmaChat-Message', { detail: message }));
  }

  static #setStatus(id, status) {
    window.dispatchEvent(new CustomEvent('SigmaChat-Status', { detail: {id, status} }));
  }

  static sendMessage(data) {
    if(!data.message && !data.attachment){
      console.error('Sigma Chat: No message or attachment. At least one is required');
      return;
    }
    const formData = new FormData();

    var messageId = data.id || uuidv4();
    formData.append('id', messageId);
    formData.append('message', data.message);
    formData.append('clientId', this.#clientId);
    Object.entries(this.#user).forEach((data) => {
      formData.append(`user[${data[0]}]`, data[1]);
    });
    if (data.attachment) {
      formData.append('attachment', data.attachment);
    }

    const options = {
      method: 'POST',
      body: formData
    }
    fetch(process.env.MIX_PUSHER_HOST + '/' + SigmaChat.#options.channel + '/sigmaV2/callback/' + SigmaChat.#options.id, options)
      .then(response => {
        if(response.ok){
          SigmaChat.#setStatus(messageId, 'sent');
        }else {
          SigmaChat.#setStatus(messageId, 'failed');
        }
      })
      .catch(error => {
        SigmaChat.#setStatus(messageId, 'failed');
      });
  }

  static sendInteractiveMessage(label, value){

    var messageId = uuidv4();
    const formData = new FormData();
    formData.append('id', messageId);
    formData.append('message', label);
    formData.append('button[label]', label);
    formData.append('button[value]', value);
    formData.append('clientId', this.#clientId);
    Object.entries(this.#user).forEach((data) => {
      formData.append(`user[${data[0]}]`, data[1]);
    });

    const options = {
      method: 'POST',
      body: formData
    }
    fetch(process.env.MIX_PUSHER_HOST + '/' + SigmaChat.#options.channel + '/sigmaV2/callback/' + SigmaChat.#options.id, options)
      .then(response => {
        if(response.ok){
          SigmaChat.#setStatus(messageId, 'sent');
        }else {
          SigmaChat.#setStatus(messageId, 'failed');
        }
      })
      .catch(error => {
        SigmaChat.#setStatus(messageId, 'failed');
      });
  }

  static initChat(user = null, clientId = null) {
    if(user){
      this.#user = user;
    }
    if(clientId){
      this.#clientId = clientId;
    }
    this.#startChat();
  }

  static #checkStatus() {
    if(SigmaChat.#healthCheck) {
      return;
    }
    SigmaChat.#healthCheck = setInterval(() => {
      if(SigmaChat.#state === Echo.connector.pusher.connection.state){
        return;
      }
      SigmaChat.#state = Echo.connector.pusher.connection.state;
      window.dispatchEvent(new CustomEvent('SigmaChat-Connection', { detail: {status: SigmaChat.#state} }));
      if (SigmaChat.#state == 'connected') {
          const formData = new FormData();
          formData.append('event', 'connected');
          formData.append('datetime', moment().toISOString());
          formData.append('clientId', SigmaChat.#clientId);
          const options = {
            method: 'POST',
            body: formData
          }
          fetch(process.env.MIX_PUSHER_HOST + '/' + SigmaChat.#options.channel + '/sigmaV2/callback/' + SigmaChat.#options.id, options);
      }
    }, 1000);
  }

  static connect() {
    SigmaChat.#connectSocket();
    this.#checkStatus();

  }

  static #terminate() {
    if(sessionStorage && SigmaChat.#options.keepHistory) {
      sessionStorage.removeItem('sigma-chat-history');
    }
    if(this.#clientId){
      const formData = new FormData();
      formData.append('message', '!sigma@@terminate');
      formData.append('clientId', this.#clientId);
      Object.entries(this.#user ).forEach((data) => {
        formData.append(`user[${data[0]}]`, data[1]);
      });
      const options = {
        method: 'POST',
        body: formData
      }
      fetch(process.env.MIX_PUSHER_HOST + '/' + SigmaChat.#options.channel + '/sigmaV2/callback/' + SigmaChat.#options.id, options);
      this.#clientId = null;
    }
    Echo.disconnect();
    if(SigmaChat.#healthCheck){
      clearInterval(SigmaChat.#healthCheck);
      SigmaChat.#healthCheck = null;
      SigmaChat.#state = 'disconected';
    }
  }

  static close() {
    SigmaChat.#terminate();
  }

  static getState() {
    return SigmaChat.#state;
  }

}

